import { useRef, useState } from "react";
import type { FC } from "react";
import { useTheme } from "@material-ui/core/styles";
import { Link as RouterLink } from "react-router-dom";
import AlertMessage from "src/components/ui-components/AlertMessage";
import {
  Avatar,
  Box,
  ButtonBase,
  Divider,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Popover,
  Typography,
  CardHeader,
  Tooltip,
} from "@material-ui/core";
import { ExitToApp } from "@material-ui/icons";
import useAuth from "../../hooks/useAuth";
// import useSettings from '../../hooks/useSettings';
import UserIcon from "../../icons/User";

const UserPopup: FC = () => {
  const anchorRef = useRef<HTMLButtonElement | null>(null);
  const { user, logout } = useAuth() as any;
  const theme = useTheme();
  const [open, setOpen] = useState<boolean>(false);
  // const { settings, saveSettings } = useSettings();

  const handleOpen = (): void => {
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  const handleLogout = async (): Promise<void> => {
    try {
      handleClose();
      await logout();
    } catch (err) {
      AlertMessage({ type: "error", msg: "Unable to logout" });
    }
  };

  const truncationStyle = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '150px',
  };

  return (
    <>
      <Box
        component={ButtonBase}
        onClick={handleOpen}
        ref={anchorRef}
        sx={{
          alignItems: "center",
          display: "flex",
        }}
      >
        <Avatar
          src={user.avatar}
          sx={{
            height: 38,
            width: 38,
            color: theme.palette.mode === "dark" ? "#FFFFFF" : "#155e96",
            // 'primary.main',
            backgroundColor:
              theme.palette.mode === "dark" ? "#155e96" : "#FFFFFF",
            // 'success.contrastText'
          }}
        >
          {/* {
            (() => {
              const fullNameArray = user.fullName.split(' ');
              return fullNameArray.length > 1 ? (`${fullNameArray[0][0]?.toUpperCase()}${fullNameArray[1][0]?.toUpperCase()}`) : fullNameArray[0][0];
            })()
          } */}
        </Avatar>
      </Box>
      <Popover
        anchorEl={anchorRef.current}
        anchorOrigin={{
          horizontal: "center",
          vertical: "bottom",
        }}
        getContentAnchorEl={null}
        keepMounted
        onClose={handleClose}
        open={open}
        style={{ top: "2%" }}
        PaperProps={{
          style: { width: 240 },
        }}
      >
        <Box>
          <CardHeader
            avatar={
              <Avatar
                src={user.avatar}
                sx={{
                  height: 40,
                  width: 40,
                  // color: 'black',
                  // backgroundColor: 'red'
                }}
              />
            }
            title={
              <Tooltip title={user.fullName}>
                <Typography sx={truncationStyle}>{user.fullName}</Typography>
              </Tooltip>
            }
            subheader={
              <Tooltip title={user.configUserGroup}>
                <Typography sx={truncationStyle}>{user.configUserGroup}</Typography>
              </Tooltip>
            }
          />
        </Box>
        <Divider />
        <Box>
          <MenuItem
            component={RouterLink}
            to="/userProfile"
            onClick={handleClose}
          >
            <ListItemIcon>
              <UserIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography color="textPrimary" variant="subtitle2">
                  Profile
                </Typography>
              }
            />
          </MenuItem>
          {/* <MenuItem>
            <ListItemIcon>
              {settings.theme === THEMES.LIGHT ? (
                <DarkMode />
              ) : (
                <WbSunnyOutlined fontSize="small" />
              )}
            </ListItemIcon>
            <ListItemText
              primary={
                settings.theme === THEMES.LIGHT ? (
                  <Typography
                    color="textPrimary"
                    variant="subtitle2"
                    onClick={() => {
                      saveSettings({ ...settings, theme: THEMES.DARK });
                    }}>
                    Dark
                  </Typography>
                ) : (
                  <Typography
                    color="textPrimary"
                    variant="subtitle2"
                    onClick={() => {
                      saveSettings({ ...settings, theme: THEMES.LIGHT });
                    }}>
                    Light
                  </Typography>
                )
              }
            />
          </MenuItem> */}
          <MenuItem>
            <ListItemIcon>
              <ExitToApp fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography
                  color="textPrimary"
                  variant="subtitle2"
                  onClick={handleLogout}
                >
                  Logout
                </Typography>
              }
            />
          </MenuItem>
        </Box>
        {/* <Box sx={{ p: 2 }}>
          <Button
            color="primary"
            fullWidth
            onClick={handleLogout}
            variant="outlined"
          >
            Logout
          </Button>
        </Box> */}
      </Popover>
    </>
  );
};

export default UserPopup;
